export default __webpack_public_path__ + "static/media/ic-back-arrow (1).5b6c5320.svg";